<template>
	<div class="content">
		<section
			id="hero"
			class="container-expanded container band"
		>
			<h1>The Truth About Student Behaviour</h1>
			<p>Adam Voigt’s The Truth About Student Behaviour is available as a free eBook and in hard copy</p>
		</section>

		<section
			id="book"
			class="cols container-expanded container-no-pad"
		>
			<div class="col col-6">
				<div class="col-inner col-center col-center-vert">
					<img
						:src="bookImage"
						alt="The Truth About Student Behaviour book cover"
					/>
				</div>
			</div>
			<div
				id="book-details"
				class="col col-6"
			>
				<div class="col-inner col-center-vert">
					<h2>Simple shifts to transform classroom chaos into calm</h2>
					<h3>By Adam Voigt</h3>
					<p>Adam speaks directly to the humans who teach, lead and care for our young people every day. With honesty, clarity and a healthy dose of humour, he strips away the guilt and fear that so often sit beneath behaviour challenges, replacing them with practical, hopeful guidance you can use straight away.</p>
					<p>Alongside sharp, simple Dos and Don’ts, teachers will find something far more powerful: real stories from real schools.</p>
				</div>
			</div>
		</section>

		<section
			id="quote"
			class="container-expanded container cols band"
		>
			<div class="col col-2" />
			<div class="col col-center text-center">
				<h3>‘The Truth About Student Behaviour cuts through noise, nostalgia and distraction. It names the truths schools, and indeed systems, have avoided for too long and offers a clear, practical pathway grounded in relationships, responsibility and culture.’</h3>
				<h4>Martine Gill, Principal, Clover Hill State School</h4>
			</div>
			<div class="col col-2" />
		</section>

		<section
			id="options"
			class="container-expanded container band"
		>
			<div class="cols">
				<div class="col col-12 text-center">
					<h2>Access to The Truth About Student Behaviour for partner schools</h2>
				</div>
			</div>
			<div class="cols">
				<div class="col col-6">
					<h4>Free eBook</h4>
					<p>The Truth About Student Behaviour is available as a free eBook, to read in Apple Books or on your Kindle.</p>
					<a
						href="https://realschools.com.au/books/student-behaviour/ebook/thank-you/"
						target="_blank"
						class="btn btn-small btn-navy"
						>Download here</a
					>
				</div>

				<div class="col col-6">
					<h4>Hard copy</h4>
					<p>We get it – you want a hard copy so you can make notes, bookmark pages and highlight the best bits.</p>
					<router-link
						:to="{
							name: 'book-purchase',
							hash: '#student-behaviour',
						}"
						class="btn btn-small btn-navy"
					>
						Order here
					</router-link>
				</div>
			</div>
		</section>

		<section class="container cols band">
			<div class="col col-2" />
			<div class="col col-8 col-center text-center">
				<h3>The stories behind the book</h3>
				<p>This book is punctuated with real stories from real schools. These stories are the heartbeat of the book, showing what’s possible when we choose connection over control and progress over perfection.</p>
				<div>
					<a
						href="https://realschools.com.au/books/student-behaviour/stories/thankyou/"
						target="_blank"
						class="btn btn-small btn-navy"
						>Listen here</a
					>
				</div>
			</div>
			<div class="col col-2" />
		</section>
	</div>
</template>

<script lang="ts">
import { defineComponent, type PropType } from 'vue';
import bookImage from '@/images/ttasb-book.webp';
import type { Resource } from '@/interfaces/resourceInterface';

export default defineComponent({
	props: {
		resource: {
			type: Object as PropType<Resource>,
			required: true,
		},
	},
	data() {
		return {
			bookImage,
		};
	},
});
</script>

<style scoped lang="scss">
#hero {
	display: flex;
	flex-direction: column;
	justify-content: center;
	align-items: center;
	margin: 0;
	background-color: rgb(var(--rs-color-brand-tomato));
	min-height: 300px;
	text-align: center;

	h1,
	h2,
	p {
		margin: 0;
		color: white;
	}

	h2 {
		margin: 20px 0 40px 0;
	}
}

#book {
	img {
		width: clamp(200px, 100%, 300px);
	}

	#book-details {
		background-color: #eaeef1;
	}
}

#quote {
	background-color: rgb(var(--rs-color-brand-navy));
	color: white;

	h3 {
		color: rgb(var(--rs-color-brand-mustard));
	}
}

#options {
	background-color: rgb(var(--rs-color-brand-tomato));
	color: white;

	h2 {
		margin: 20px 0 60px 0;
		color: white;
	}

	h4 {
		color: white;
	}

	.btn {
		margin-top: 40px;
	}

	@media screen and (width >= 640px) {
		.col {
			padding: 0 30px;
		}
	}
}
</style>
